/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum ParamType {
    encoded = 'encodedParam', // only one that is custom to XM
    path = 'path',
    query = 'query',
    any = 'any'
}

export enum FormType {
    blur = 'blur',
    submit = 'submit',
    default = 'change'
}

export enum ApiChannel {
    CMS = 'CMS',
    PROXY_CMS = 'PROXY_CMS',
    PROXY_GATEWAY = 'PROXY_GATEWAY',
    PROXY_LOGGER = 'PROXY_LOGGER',
    LOGGER = 'LOGGER',
    CMS_LIVE = 'CMS_LIVE',
    CIMA_WEB = 'CIMA_WEB',
    GATEWAY = 'GATEWAY',
    PROXY = 'PROXY',
    AKAMAI_PROXY = 'AKAMAI_PROXY',
    INBENTA = 'INBENTA',
    MOCKABLE = 'MOCKABLE',
    PCAT = 'PCAT',
    XAPI = 'XAPI',
    SSM_GATEWAY = 'SSM_GATEWAY',
    BREEZE = 'BREEZE',
    BROADBAND_LABELS = 'BROADBAND_LABELS'
}

export enum BreakpointWidth {
    MOBILE = 320,
    TABLET = 640,
    SMALL_DESKTOP = 960,
    LARGE_DESKTOP = 1280
}

export enum ImageFit {
    HEIGHT = 'height',
    WIDTH = 'width',
    CONTAIN = 'contain'
}

export enum StorageToken {
    CIMA = 'xm-new-access-token',
    MBC = 'xm-mbc-access',
    SAVED_STATE = 'XM_SAVED_STATE',
    SAVED_FAILED_REQUESTS = 'xm-failed-requests',
    CUSTOMIZING_ITEM = 'CUSTOMIZING_ITEM',
    BYOD_PORT_COUNT = 'BYOD_PORT_COUNT',
    TPS = 'TPS',
    ADOBE = 'XM-ANALYTICS',
    SHARED_CARTS = 'xfinityCart',
    CIMA_USER_ACCOUNT_GUID = 'acc',
    CIMA_STEP_UP_ERROR = 'error',
    USER_GRANT_TOKEN = 'xm-user-access-token',
    VERIFICATION_REFERENCE_NUMBER = 'VERIFICATION_REFERENCE_NUMBER',
    SAVED_AMOUNT = 'XM_SAVED_AMOUNT',
    CPC_NETWORK_INFO = 'CPC_NETWORK_INFO',
    X_TENANT_ID = 'X-Tenant-Id'
}

export enum TransitionHooks {
    START = 'transitionStart',
    SUCCESS = 'transitionSuccess',
    PARAMS = 'paramsChanged'
}

export const PASSIVE_OAUTH_BLACKLIST: RegExp[] = [
    /account.u.standalone-hop/,
    /standalone.landing/
];

export enum DeviceType {
    TABLET = 'TABLET',
    PHONE = 'PHONE',
    SMART_WATCH = 'SMART_WATCH'
}

export const BUTTON_LOADER_CLASS: string = 'is-loading'; // only used for JS, need to also change scss files

export const BREADCRUMB_TOKEN: string = 'breadcrumb';
export const CONFIG_TOKEN: string = 'CONFIG_TOKEN';
export const MILLISECOND_MULTIPLIER: number = 1000;
export const CENTS: number = 2;
export const ACCESSORY_ADD_CART_LIMIT: number = 10;
export const APPLE_BRAND_NAME: string = 'Apple';

export const SCREEN_READER_TEXT_LOADING: string = 'Loading';

export const CIMA_STEP_UP_ERROR: string[] = ['unmet_authentication_requirements', 'User%20login%20required', 'login_required'];

export enum PlanSku {
    SMART_WATCH_DATA = '8795486',
    BY_THE_GIG = '8420046',
    UNLIMITED = '8410397',
    FINANCED = 'RECURRING',
    PAY_IN_FULL = 'ONETIME',
    NO_XMPP = 'NO_XMPP'
}

export enum AdditionalChargeType {
    EWSTF = 'EWSTF',
    DAF = 'DAF',
    DEVICE_SUBSIDY = 'DEVICE_SUBSIDY'
}

export enum PromotionType {
    PERCENTAGE = 'PERCENTAGE',
    DOLLAR_AMOUNT = 'DOLLAR_AMOUNT',
    GIFT_CARD = 'GIFT_CARD',
    SUBSIDY = 'SUBSIDY',
    EXTENDED_PROMO = 'EXTENDED_PROMO',
    EXTENDED_PROMO_DOLLAR = 'EXTENDED_PROMO_DOLLAR',
    EXTENDED_PROMO_PCT = 'EXTENDED_PROMO_PCT',
    EXTENDED_PROMO_UPGRADE = 'EXTENDED_PROMO_UPGRADE',
    TRADEIN_PROMO = 'TRADEIN_PROMO',
    TRADEIN_PROMO_GC = 'TRADEIN_PROMO_GC',
    TRADEIN_PROMO_DDA = 'TRADEIN_PROMO_DDA',
    SERVICE_PROMO_LINE = 'SERVICE_PROMO_LINE',
    SERVICE_PROMO_LINE_BYOD = 'SERVICE_PROMO_LINE_BYOD',
    SERVICE_PROMO_ACCOUNT = 'SERVICE_PROMO_ACCOUNT',
    INSURANCE_PROMO_LINE_DISCOUNT = 'INSURANCE_PROMO_LINE_DISCOUNT',
    EXTENDED_PROMO_DOLLAR_DDA ='EXTENDED_PROMO_DOLLAR_DDA',
    TRADEIN_PROMO_PLUSUP = 'TRADEIN_PROMO_PLUSUP',
    EXTENDED_PROMO_UPGRADE_DDA = 'EXTENDED_PROMO_UPGRADE_DDA'
}

export enum PromotionOffer {
    UNLBOGO_AL_SERP = 'UNLBOGO-AL-SERP',
    BYOD_LL_SERP = 'BYOD_LL_SERP',
    UNLFREE_LL_SERP = 'UNLFREE-LL-SERP',
    UNLHL25_LL_SERP = 'UNLHL25-LL-SERP'
}

export enum ProgramType {
    TIP = 'TIP',
    ITI = 'ITI',
    EARLY_UPGRADE = 'EARLY_UPGRADE'
}

export enum MouseEventType {
    MOUSE_ENTER = 'mouseenter',
    MOUSE_LEAVE = 'mouseleave'
}

export enum FocusEventType {
    FOCUS_IN = 'focusin',
    FOCUS_OUT = 'focusout'
}

export enum CustomerType {
    NEW_NEW_CUSTOMER = 'RESIDENTIAL_NEW',
    EXISTING_CUSTOMER = 'RESIDENTIAL'
}

export enum PaymentType {
    MONTHLY = 'MONTHLY',
    ONE_TIME = 'ONE_TIME'
}

export enum TaxType {
    TAX = 'TAX',
    FEES = 'FEES'
}

export enum Height {
    NAV_BAR = 56,
    TAB_BAR_MOBILE = 37,
    TAB_BAR_DESKTOP = 50
}

export enum PlanType {
    RatePlan = 'RatePlan',
    ProtectionPlan = 'InsurancePlan',
    PaymentPlan = 'PaymentPlan'
}

export enum OS {
    ANDROID = 'ANDROID',
    IOS = 'IOS',
    WATCHOS = 'WATCHOS'
}

export enum DeviceBrand {
    APPLE = 'apple',
    SAMSUNG = 'samsung',
    LG = 'lg',
    GOOGLE = 'google',
    OTHER = 'other'
}

export enum ShopCategory {
    DEVICE = 'DEVICE',
    ACCESSORY = 'ACCESSORIES',
    TABLET = 'TABLET',
    WATCH = 'SMART_WATCH'
}

export enum ItemType {
    DEVICE = 'DEVICE',
    ACCESSORY = 'ACCESSORY',
    NDEL = 'DEVICE_EXCHANGE',
    WATCH = 'SMART_WATCH',
    TABLET = 'TABLET'
}

export enum RequestProgressStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export enum CreditCardType {
    MASTER_CARD = 'MASTERCARD',
    VISA = 'VISA',
    AMEX = 'AMEX',
    DISCOVER = 'DISCOVER',
    AMERICANEXPRESS = 'AMERICANEXPRESS'
}

export enum NumericCreditCardType {
    MASTER_CARD = '002',
    VISA = '001',
    AMEX = '003',
    DISCOVER = '004'
}

export enum Availability {
    AVAILABLE = 'AVAILABLE',
    PREORDER = 'PREORDER',
    BACKORDER = 'BACKORDER',
    OUT_OF_STOCK = 'OUT_OF_STOCK'
}

export enum KeyboardEventKeys {
    ARROW_UP = 'ArrowUp',
    ARROW_DOWN = 'ArrowDown',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_RIGHT = 'ArrowRight',
    ENTER = 'Enter',
    SPACE = ' ',
    ESCAPE = 'Escape',
    HOME = 'Home',
    END = 'End',
    TAB = 'Tab',
    BACKSPACE = 'Backspace',
    DELETE = 'Delete'
}

export enum MBCMessageCodes {
    SESSIONLOCKED = 'MBC-8027',
    RETRY = 'MBC-8028',
    DUPLICATE_NICKNAME = 'MBC-7066',
    CANT_PORT = 'MBC-7072',
    NEW_NEW_DEVICE_LIMIT = 'MBC-7288',
    DEVICE_LIMIT = 'MBC-7052',
    DEVICE_LIMIT_WITH_ITEM_IN_CART = 'MBC-7331',
    PREORDER_DEVICE_LIMIT = 'MBC-7117',
    ADD_LIMIT_PREORDER_IN_CART = 'MBC-7119',
    ADD_LIMIT_BACKORDER_IN_CART = 'MBC-7226',
    ADD_LIMIT_NDEL_IN_CART = 'MBC-7278',
    CHECKOUT_LIMIT_PREORDER_IN_CART = 'MBC-7118',
    CHECKOUT_LIMIT_BACKORDER_IN_CART = 'MBC-7227',
    CHECKOUT_LIMIT_NDEL_IN_CART = 'MBC-7280',
    INSUFFICIENT_FUNDS = 'MBC-7312',
    INVALID_CARD = 'MBC-7313',
    FORCE_ECC = 'MBC-7305',
    ILC_PARTIAL_SUCCESS = 'MBC-7303',
    ECC_PARTIAL_SUCCESS = 'MBC-7304',
    CREDIT_CHECK_HARD_STOP = 'MBC-7307',
    CREDIT_CHECK_DONE = 'MBC-7306',
    INVALID_SSN = 'MBC-7092',
    INVALID_DOB = 'MBC-7009',
    CREDIT_CHECK_UNAVAILABLE = 'MBC-8027',
    CONTACT_CREDIT_BUREAU = 'MBC-7347',
    CREDIT_BUREAU_UNAVAILABLE = 'MBC-7348',
    BYOD_DUPLICATE_IMEI = 'MBC-7064',
    PIF_NDEL = 'MBC-7332',
    PORTIN_SAME_NUMBER = 'MBC-7292',
    NEGOTIABLE_ITEM = 'MBC-7333',
    DOWNPAYMENT_AMOUNT_CHANGE = 'MBC-7334',
    WATCH_BUY_INELIGIBLE = 'MBC-7321',
    ACCESSORY_MAX_LIMIT = 'MBC-7328',
    LAST_IPHONE_IN_CART = 'MBC-7337',
    ADD_PREORDER_BACKORDER_WATCH = 'MBC-7340',
    ADD_WATCH_PREORDER_IPHONE_IN_CART = 'MBC-7341',
    ADD_DEVICE_PREORDER_WATCH_IN_CART = 'MBC-7342'
}

export enum LineEligibilityConditionalCodes {
    HAS_XMPP = 'NDEL500',
    PAID_IN_FULL = 'UPEL300',
    PAID_HALF = 'UPEL400'
}

export enum FullfillmentMethods {
    FEDEX_2_DAY = 'FEDEX_2_DAY'
}

export enum Brand {
    IPHONE = 'iPhone',
    GALAXY = 'Galaxy',
    PIXEL = 'Pixel'
}

export enum BUY_CHANNEL {
    ONLINE = 'ONLINE',
    RETAIL= 'RETAIL',
    TELESALES = 'TELESALES',
    RETAIL_INSTORE = 'RETAIL_INSTORE'
}

export enum ProductCategory {
    PHONE = 'PHONE',
    ACCESSORY = 'ACCESSORY',
    TABLET = 'TABLET',
    SMART_WATCH = 'SMART_WATCH'
}

export enum PlanGroupType {
    BY_THE_GIG = 'BY_THE_GIG',
    BY_THE_GIG_SHARED = 'BY_THE_GIG_SHARED',
    UNLIMITED = 'UNLIMITED',
    SMART_WATCH = 'SMART_WATCH',
    ACCESSORY = 'ACCESSORY',
    XMPP = 'XMPP'
}

export const XMPP_NAME: string = 'Xfinity Mobile Protection Plan';

export enum PaymentPlanName {
    FINANCED = 'Monthly',
    PAY_IN_FULL = 'Pay In Full'
}

export enum AccountType {
    LEVEL_1 = 'LEVEL_1',
    LEVEL_2 = 'LEVEL_2',
    LEVEL_3 = 'LEVEL_3',
    LEVEL_4 = 'LEVEL_4',
    LEVEL_5 = 'LEVEL_5',
    IN_TRANSITION = 'IN_TRANSITION',
    BLOCKED = 'BLOCKED'
}

export enum IsMobileCustomer {
    YES = 'Yes',
    NO = 'No'
}

export enum Manufacturer {
    APPLE = 'APPLE',
    GOOGLE = 'GOOGLE',
    SAMSUNG = 'SAMSUNG',
    UNKNOWN = 'UNKNOWN'
}

export const AUTH_COOKIE_NAME: string = 'isAuth';

export enum AuthCookieValue {
    SET = '1',
    UNSET = '0'
}

export const MY_ACCOUNT: string = 'My Account';

export enum A11yClassName {
    RECEIVE_FOCUS = 'receive-focus'
}

export enum XmppStatus {
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED'
}

export enum SortOptions {
    A_Z = 'a-z',
    NEWEST = 'newest',
    MOST_DATA = 'most-data-used',
    LEAST_DATA = 'least-data-used',
    ACTIVATION_STATUS = 'activation-status',
    PAYMENTS_HIGH_LOW = 'payments-high-low',
    PAYMENTS_LOW_HIGH = 'payments-low-high'
}

export enum LineTransferAccountType {
    SOURCE = 'SOURCE',
    TARGET = 'TARGET'
}

export enum ResolutionStatus {
    HIGH = 'HIGH',
    LOW = 'LOW'
}

export enum DenialVideoResolutionReasons {
    VIDRESELIG_INVALID_SEGMENT = 'VIDRESELIG_INVALID_SEGMENT',
    VIDRESELIG_LINE_INACTIVE = 'VIDRESELIG_LINE_INACTIVE',
    VIDRESELIG_INVALID_DEVICE = 'VIDRESELIG_INVALID_DEVICE',
    VIDRESELIG_INVALID_RATEPLAN = 'VIDRESELIG_INVALID_RATEPLAN',
    VIDRESELIG_PENDING_ORDER = 'VIDRESELIG_PENDING_ORDER'
}

export enum LoggerEvent {
    MEASURE = 'measure',
    ERROR = 'error',
    OTHERS = 'others'
}

export const CORE_API_LIST: string[] = ['/account/lines', '/customer/account'];

export enum UserType {
    RESIDENTIAL = 'Residential',
    BUSINESS = 'Commercial'
}

export enum LoggerOptions {
    LOGGER_NAME = 'XM My Account Web',
    COMPONENT = 'account-home',
    APP_NAME = 'xm-my-account-web',
    NOW_APP_NAME = 'now-mobile-my-account-web',
    NOW_COMPONENT = 'now-account-home'
}

export const logMaskFields: string[] = ['email', 'primaryPhone', 'name', 'firstName', 'lastName', 'displayName', 'sms', 'contactEmail', 'contactNumber', 'ccLastFour', 'oneTimeEmailId'];

export const SPINNER_BLACKLIST: RegExp[] = [ /standalone-hop/ ];

export const CMB_SSO_QUERY: string = 'cbmya_sso';

export const CABLE_CONTEXT_ID: string = 'context_id';

export const CBM_BUYFLOW: string = 'https://business.comcast.com/mobile';

export const SMART_WATCH: string = 'Smart Watch';

export const NOW_FAVICON_URL: string = 'https://assets.xfinity.com/assets/dotcom/projects_2/now-service-screens/NOW_Favicon_Template_32x32px_AW.svg';

export const CONTACT_NOT_SEASONED: string = 'CONTACT_NOT_SEASONED';

export const TOO_MANY_ATTEMPTS: string = 'TOO_MANY_ATTEMPTS';

export enum TooltipPosition {
    ABOVE = 'above',
    BELOW = 'below',
    LEFT = 'left',
    RIGHT = 'right',
    DEFAULT = 'above'
}

export enum FeatureID {
    GENERIC = 'generic',
    GENERIC_NEW_PLANS = 'new_plans',
    GENERIC_PLANS_DETAILS = 'plan_details',
    FIVEG = '5g',
    RECOMMENDATION_PROMOTION = 'recommendationPromotion',
    TABLET_WITH_OTHER_LINES_WITH_PROMOTIONS = 'tabletWithOtherLinesWithPromotions',
    TABLET_WITH_OTHER_LINES_WITHOUT_PROMOTIONS = 'tabletWithOtherLinesWithoutPromotions',
    TABLET_ONLY_WITH_PROMOTIONS = 'tabletsOnlyWithPromotions',
    TABLET_ONLY_WITHOUT_PROMOTIONS = 'tabletOnlyWithNoPromotions',
    GENERIC_PHONE_TABLET_RESIDENTIAL = 'genericPhoneTabletResidential',
    GENERIC_PHONE_TABLET_WITH_PROMOTIONS = 'genericPhoneTabletWithPromotions',
    GENERIC_PHONE_TABLET_WITHOUT_PROMOTIONS = 'genericPhoneTabletWithoutPromotions'
}

export enum NewCookieConsentIds {
    DATA_DOMAIN_ID_LOWERS = '018ef173-39d8-7323-b3a3-59dd7440360b',
    DATA_DOMAIN_ID_PROD = 'a55e6907-e160-4758-bc91-65f5b89f37b3'
}

export enum EligibilityStatus {
    EARLY_UPGRADE_ELIGIBLE_WITHOUT_FEE = 'EARLY_UPGRADE_ELIGIBLE_WITHOUT_FEE',
    EARLY_UPGRADE_ELIGIBLE_WITH_FEE = 'EARLY_UPGRADE_ELIGIBLE_WITH_FEE',
    UPGRADE_ELIGIBLE = 'UPGRADE_ELIGIBLE',
    UPGRADE_INELIGIBLE = 'UPGRADE_INELIGIBLE',
    EARLY_UPGRADE_ELIGIBLE_WITH_DEVICE_PAYMENT_AND_WITH_FEE = 'EARLY_UPGRADE_ELIGIBLE_WITH_DEVICE_PAYMENT_AND_WITH_FEE',
    EARLY_UPGRADE_ELIGIBLE_WITH_DEVICE_PAYMENT_AND_WITHOUT_FEE = 'EARLY_UPGRADE_ELIGIBLE_WITH_DEVICE_PAYMENT_AND_WITHOUT_FEE'
}

export const FEATURE_FLAGS: string[] = [
    'ENABLE_DSS_LOGGER',
    'ENABLE_COOKIE_CONSENT',
    'ENABLE_NEW_COOKIE_CONSENT'
];

export enum PaymentErrorCode {
    PAYMENT_5050 = 'PAYMENT-5050',
    PAYMENT_5051 = 'PAYMENT-5051'
}

export enum AccountLockedErrorCode {
    NM_TO_XM_UPGRADE_INPROGRESS = 'NM_TO_XM_UPGRADE_INPROGRESS'
}
